import { useTranslation } from 'react-i18next';

import { useSubscriptionByChannelIdQuery } from '@/entities/billing';
import { ISubscriptionResponseDto } from '@/shared/api/subscriptions';
import { useAppQuery, UseAppQueryOptions } from '@/shared/lib/useAppQuery';
import { ApiError } from '@/shared/api/ApiError';

export const useSubscriptionByChannelId = (
  channelId: string,
  options?: Omit<
    UseAppQueryOptions<ISubscriptionResponseDto, ApiError>,
    'queryFn' | 'queryKey'
  >
) => {
  const { i18n } = useTranslation();
  const { data, isLoading, isError } = useAppQuery({
    ...useSubscriptionByChannelIdQuery(channelId),
    ...options,
    enabled: Boolean(channelId),
  });

  const formattedEndDate = data?.end_date
    ? new Date(data.end_date).toLocaleDateString(i18n.language)
    : null;

  return {
    data,
    endDate: formattedEndDate,
    isLoading,
    isError,
  };
};
